import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { BtnChiTietHopDong } from "./ChiTietHopDong/BtnChiTietHopDong";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";
import { catChuoi } from "utils/stringExtension";
import { BtnChiTietHopDongNhanVay } from "./ChiTietHopDongNhanVay/BtnChiTietHopDong";
import { getListThuDelete } from "../../../actions/DanhSachThuDelete";
import { BtnKhoiPhucPhieu } from "components/ThongKe/KhoiPhucPhieuBiXoa/BtnKhoiPhucPhieu";
import { useCoTheKhoiPhuc } from "components/ThongKe/KhoiPhucPhieuBiXoa/useCoTheKhoiPhuc";

export const ContentTable = ({ listThuDeleteFull, quyenXoa, quyenKhoiPhuc }) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchThuDelete);
  const taiLaiDanhSach = () => dispatch(getListThuDelete(dataSearch));
  const coTheKhoiPhuc = useCoTheKhoiPhuc(listThuDeleteFull.list, quyenKhoiPhuc);
  return listThuDeleteFull.list.map((item, index) => (
    <div className="custom-table-row" key={item.ThuChiID || "row" + index}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.Idx}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-12-8-sm">
        <span className="mobile-column-name">Ngày giao dịch</span>
        <div className="center-wrapper">
          <p className="text-center color7">{getDate(item.Time)}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-12-6-sm">
        <span className="mobile-column-name">Người nộp</span>
        <div className="center-wrapper">
          <p className="text-left color7 word-break">{item.Name}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-9-2-sm">
        <span className="mobile-column-name">Mã hợp đồng</span>
        <div className="center-wrapper">
          <p className="text-center color-xanh-bold">
            {item.NhanVayId && <BtnChiTietHopDongNhanVay item={item} />}
            {!item.NhanVayId && <BtnChiTietHopDong item={item} />}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-11-sm">
        <span className="mobile-column-name">Loại</span>
        <div className="center-wrapper color7">
          {item.Type === 1 && <p className="text-left">Kỳ lãi</p>}
          {item.Type === 11 && <p className="text-left">Tất toán</p>}
          {item.Type === 17 && <p className="text-left">Trả bớt gốc</p>}
          {item.Type === 21 && <p className="text-left">Vay thêm</p>}
          {item.Type === 2 && <p className="text-left">Chi cho vay</p>}
          {item.Type === 4 && <p className="text-left">Thu nhận vay</p>}
          {item.Type === 24 && <p className="text-left">Thu phí khác</p>}
          {item.Type === 16 && <p className="text-left">Thanh lý tài sản</p>}
          {item.Type === 30 && <p className="text-left">Chi hoa hồng</p>}
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-12-8-sm">
        <span className="mobile-column-name">Tiền thu</span>
        <div className="center-wrapper">
          <p className="text-right color7">{formatNumber(item.Value)}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-17 flex-basis-13-sm">
        <span className="mobile-column-name">Người xoá</span>
        <div className="center-wrapper">
          <p className="text-left color7 word-break" title={item.UpdatedUser}>
            {catChuoi(item.UpdatedUser, 30)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-13 flex-basis-15-sm">
        <span className="mobile-column-name">Ngày xoá</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.UpdatedTime}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-11 flex-basis-8-6-sm  action-cell">
        <div className="center-wrapper">
          <div className="iconTableMormanCenter">
            {coTheKhoiPhuc(item) && (
              <BtnKhoiPhucPhieu item={item} onDaKhoiPhuc={taiLaiDanhSach} />
            )}
            {quyenXoa && <BtnXoa Id={item.ThuChiID} />}
          </div>
        </div>
      </div>
    </div>
  ));
};
